import React, { useEffect, useRef, useState } from "react";
import api from "../lib/api";
import PageNotFound from "./PageNotFound";

// Continuous, role-scoped IP enforcement on the client. The backend is the source of
// truth: every authenticated request is IP-checked and returns 403 {ip_blocked} when the
// session's IP is no longer approved. This component (a) reacts to that signal by swapping
// the whole UI for the existing Page Not Found screen, and (b) runs a 30s heartbeat so a
// left-open page is revoked even without user interaction. When the IP becomes approved
// again the heartbeat succeeds and we reload to restore access — no logout required.
const HEARTBEAT_MS = 30000;

export default function IpGuard() {
  const [blocked, setBlocked] = useState(false);
  const blockedRef = useRef(false);

  useEffect(() => {
    const onBlock = () => { blockedRef.current = true; setBlocked(true); };
    window.addEventListener("lx-ip-blocked", onBlock);
    return () => window.removeEventListener("lx-ip-blocked", onBlock);
  }, []);

  useEffect(() => {
    const tick = async () => {
      if (!localStorage.getItem("lm_token")) return;
      try {
        await api.get("/session/ip-status");
        // Was blocked, now approved again -> restore cleanly.
        if (blockedRef.current) { blockedRef.current = false; window.location.reload(); }
      } catch (e) {
        /* interceptor raises lx-ip-blocked when the failure is an ip_blocked 403 */
      }
    };
    tick();
    const id = setInterval(tick, HEARTBEAT_MS);
    return () => clearInterval(id);
  }, []);

  if (!blocked) return null;
  return <PageNotFound />;
}
